import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Button, Heading, Link, Subtitle, Text } from 'mondrian-react';
import EcomMenu from '../../../components/EcomMenu';
import Footer from '../../../components/Footer';

import styles from './styles.module.scss';
import { useRouter } from 'next/router';
import { SessionStorageKeys } from '../../../types/SessionStorageKeys';
import CroService from '../../../services/CroService';
import StoryBlokService from '../../../services/StoryBlokService';

const Error500Component: React.FC = () => {
  const MONTE_SUA_COMBINACAO_URL = `${process.env.prospectUrl}/monte-sua-combinacao`;
  const router = useRouter();
  const [storyBlokConfig, setStoryBlokConfig] = useState<unknown>()

  const handleOnClick = (e?: SyntheticEvent<Element, Event>): void => {
    e.preventDefault();
    CroService.postDataLayer({
      event: 'event',
      eventCategory: 'planos-claro-res:cobertura:erro-500',
      eventAction: 'clique:navegacao',
      eventLabel: 'avancar-para-home'
    });
    const cep = sessionStorage.getItem(SessionStorageKeys.CEP_JA_SOU_CLIENTE);
    const numero = sessionStorage.getItem(SessionStorageKeys.NUMERO_JA_SOU_CLIENTE);

    if (!!cep && !!numero) {
      const url = `${MONTE_SUA_COMBINACAO_URL}?cep=${cep}&number=${numero}`
      window.location.href = url;
    } else {
      router.push('/');
    }
  }

  useEffect(() => {
    // IIFE (Immediately Invoked Function Expression)
    (async () => {
      try {
        const response = await StoryBlokService.getConfig('regras-gerais');
        setStoryBlokConfig(response);

      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    })();
  }, []);

  const redirectWhatsapp = (): void => {
    window.location.href = "https://claro-e.com/IRScx";
    CroService.postDataLayer({
      event: 'event',
      eventCategory: 'planos-claro-res:cobertura:erro-500',
      eventAction: 'clique:link',
      eventLabel: 'ligar-whatsapp'
    });
  }

  return (
    <div id="error-500-page-wrapper" className={styles.pageWrapper}>
      <EcomMenu
        storyBlok={storyBlokConfig}
      />

      <main className={`mdn-Container ${styles.pageContent}`}>
        <div>
          <Heading xl className={styles.mdnHeading}>
            Ops, algo deu errado.
          </Heading>

          <div className={`mobile-illustration ${styles.mobileIllustration}`}></div>

          <Subtitle md>
            Desculpe, a página que você está procurando não foi encontrada.
          </Subtitle>

          <Text body className={styles.mdnText}>
            O que pode ter acontecido?
          </Text>

          <Text body>
            O servidor pode estar sendo atualizado ou em manutenção.
          </Text>

          <Text body>
            Verifique novamente em alguns minutos ou, para comprar ligue na nossa central de vendas.
          </Text>

          <Button id="mais-ofertas-btn" className={styles.maisOfertasBtn} onClick={handleOnClick}>
            Fazer uma nova consulta
          </Button>
        </div>

        <div className={`desktop-illustration ${styles.desktopIllustration}`}></div>

        <div className={`whatsapp-container ${styles.whatsappContainer}`} onClick={redirectWhatsapp}>
          <img src="https://mondrian.claro.com.br/brands/app/72px-default/whatsapp.svg" alt="WhatsApp"></img>
        </div>

      </main>
      <Footer
        storyBlok={storyBlokConfig}
      />
    </div>

  )
}

export default Error500Component;
